import React, { Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import PageContainer from '../_common/PageContainer';
import { PageHeaderUIContainer } from '../_common/PageHeaderUi';
import LinearProgress from 'components/_common/LinearProgress';
import { MobileReportWrapper } from 'components/Overview/OverviewMobile';
import { mobileStyles } from './MobileSettings.styles';
import MobilePreferences from './MobilePreferences';
import MobileDTFUnits from './MobileDTFUnits';
import MobileLanguage from './MobileLanguage';

const MobileSettings = props => {
  const {
    userSettings,
    updatedSettings,
    isProductionHoursConfigured,
    handleChangeDefaultValue,
    handleChangeViewMode,
    handleChangeLength,
    handleChangeMetrics,
    handleChangeLang,
  } = props;
  const { t } = useTranslation();

  return (
    <MobileReportWrapper reportHeight={'850px'}>
      <PageContainer>
        <PageHeaderUIContainer>
          <Box sx={mobileStyles.titleWrapper}>
            <Box component="img" src="/img/setting-icon.svg" sx={mobileStyles.icon} />
            <Typography variant="h1" sx={mobileStyles.title}>
              {t('settings.settings')}
            </Typography>
          </Box>
        </PageHeaderUIContainer>
        {!userSettings.isLoading ? (
          <Box sx={mobileStyles.settingsWrapper}>
            <Box sx={mobileStyles.leftPart}>
              <MobilePreferences
                userSettings={userSettings}
                updatedSettings={updatedSettings}
                isProductionHoursConfigured={isProductionHoursConfigured}
                handleChangeDefaultValue={handleChangeDefaultValue}
                handleChangeViewMode={handleChangeViewMode}
              />
              <MobileDTFUnits
                userSettings={userSettings}
                updatedSettings={updatedSettings}
                handleChangeLength={handleChangeLength}
                handleChangeMetrics={handleChangeMetrics}
              />
            </Box>
            <Box sx={mobileStyles.rightPart}>
              <MobileLanguage
                userSettings={userSettings}
                updatedSettings={updatedSettings}
                handleChangeLang={handleChangeLang}
              />
            </Box>
          </Box>
        ) : (
          <LinearProgress />
        )}
      </PageContainer>
    </MobileReportWrapper>
  );
};

export default MobileSettings;
